module.exports = __webpack_public_path__ + "img/Web2Carz.2a14a01b.png";